import React from 'react'
import { useIntl } from 'react-intl'
import Modal from '@molecules/Modal/Modal'
import { Country, useConfig, FontConfig } from 'msp-integrations'
import { LocationMarkerIcon } from '@heroicons/react/solid'

type LangModal = {
  countries?: Country[]
  locale?: string
  show: boolean
  setShow: (val: boolean) => void
}

const ModalBody = ({
  countries,
  locale,
  font
}: {
  countries: Country[]
  locale: string
  font: FontConfig
}) => (
  <div className='flex w-fit flex-col flex-wrap gap-y-4 md:flex-row md:px-8 md:pb-4'>
    {countries &&
      countries?.map((country, id) =>
        country?.locales?.map((location, idx) => (
          <a
            aria-disabled={locale === location.locale}
            href={location.link}
            key={`${id}_${idx}`}
            className={`${
              font.regular
            } mb-4 flex h-fit w-fit cursor-pointer md:w-1/2 ${
              locale === location.locale
                ? 'pointer-events-none text-black'
                : 'text-machine1-75'
            } hover:text-black`}
          >
            <LocationMarkerIcon
              width='16px'
              height='16px'
              className='mr-1 mt-[0.1rem]'
            />
            <div className='flex flex-col text-[18px] text-black'>
              <span className={`${font.medium} block  leading-normal`}>
                {country?.countryName}
              </span>
              <span className='text-14 block leading-normal'>
                {location?.name}
              </span>
            </div>
          </a>
        ))
      )}
  </div>
)

const LanguageModal = ({
  countries = [],
  locale = '',
  show,
  setShow
}: LangModal) => {
  const { formatMessage } = useIntl()
  const {
    theme: { font }
  } = useConfig()
  return (
    <Modal
      isOpen={show}
      onClose={() => setShow(false)}
      overlay
      closeOnOverlayClick
      blockScroll
      modalHeader={
        <h2 className='text-24 mb-8 md:px-8'>
          {formatMessage({
            defaultMessage: 'Please choose your location and language settings',
            id: 'languagemodal.title'
          })}
        </h2>
      }
      modalBody={
        <ModalBody countries={countries} locale={locale} font={font} />
      }
      style='w-[95%] md:w-[35rem]'
    />
  )
}

export default LanguageModal
